import { handleRequest } from "../utilities/requestHandler";

export const createCase = (form) =>
    handleRequest("post", "/machines/create-case", form);